import React, {useState} from "react";
import { getData } from "app/data";
import "./CommercialEquipment.css"; 
import { rootUrl } from "config/setting";
import { FormattedMessage } from "react-intl";
import Button from "components/Button";
import WaitingFor from "components/Banner/WaitingFor";
import FlexibleBuyoutOptions from "images/custimize_images/Flexible_buyout_options.png"; 
import ThreemonthSkipLease from "images/custimize_images/Three-month_skip_lease.png";
import StepuporStepdownOption from "images/custimize_images/Step-up_or_step-down_option.png";
import FairMarketValue from "images/custimize_images/Fair_market_value.png";  
import SeasonalPaymentPeriods from "images/custimize_images/Seasonal_payment_periods.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPhoneAlt,
    faEnvelope,
    faMapMarkerAlt,
  } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as Programming } from "images/goopter-about-us-programming.svg";
import { ReactComponent as LeftBg } from "images/background/hero-section-red-triangle.svg";
import { ReactComponent as RedShadow } from "images/background/software-solution-graphic-red.svg";
import { ReactComponent as RightBg } from "images/background/right-box-graphic.svg";
import Algriculture from "images/leasable_equipment/agriculture.png";
import Construction from "images/leasable_equipment/construction.png";
import Industrial from "images/leasable_equipment/industrial.png";
import Landscaping from "images/leasable_equipment/landscaping.png";
import Medical from "images/leasable_equipment/medical.png";
import Office from "images/leasable_equipment/office.png"; 
import FeedbackCard from "./FeedbackCard"; 

export default function Index() {
    const data = getData("posDeviceData");

    return (
        <div className="commercial_page">
            <div className="commercial_page_header">
            <LeftBg className="left-bg" />
            <RedShadow className="red-shadow-bg" />
            <RightBg className="right-bg" />
                <div className="header_content_container">
                    <div className="header_title_container">
                        <h2 className="header_title"><FormattedMessage id={"lease_service"}/></h2>
                    </div>
                    <div className="header_subtitle_container">
                        <h3 className="header_subtitle"><FormattedMessage id={"unlock_business_potential"}/></h3>
                    </div>
                    <div className="header_paragraph_container">
                        <p className="header_paragraph"><span className="paragraph_leading"><FormattedMessage id={"welcome_to_service"}/> </span><FormattedMessage id={"header_introduction"}/></p>
                    </div>
                </div>
                <div className="header_link_container">
                    <a href="#our-service" className="link_button_red"><FormattedMessage id={"our_service"}/></a>
                    <a href="#how-it-works" className="link_button_green"><FormattedMessage id={"how_it_works"}/></a>
                    <a href="#leasable-equipment" className="link_button_red"><FormattedMessage id={"leasable_equipment"}/></a>
                    <a href="#why-choose-us" className="link_button_green"><FormattedMessage id={"why_choose_us"}/></a>
                    <a href="#get-start" className="link_button_red"><FormattedMessage id={"how_to_get_started"}/></a>
                    <a href="#contact-us" className="link_button_green"><FormattedMessage id={"contact_us"}/></a>
                </div>
            </div>
            <div className="background">
            <div className="section" id="our-service">
                <div className="section_content_container">
                    <div className="section_title_container">
                        <h3 className="section_title"><FormattedMessage id={"our_service"}/></h3>
                    </div>
                    <div className="paragraph_container">
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"equipment_leasing"}/></h4>
                            <p>
                                <FormattedMessage id={"what_we_offer"}/> <br/>
                                <span className="paragraph_leading"><FormattedMessage id={"operational_leases"}/> </span><FormattedMessage id={"operational_leases_introduction"}/> <br/>
                                <span className="paragraph_leading"><FormattedMessage id={"capital_leases"}/> </span><FormattedMessage id={"capital_leases_introduction"}/>
                            </p>
                        </div>
                    </div>
                    <div className="paragraph_container">
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"sale_Leaseback"}/></h4>
                            <span className="paragraph_leading"><FormattedMessage id={"turn_into_cash"}/></span>
                            <p><FormattedMessage id={"sale_leaseback_introduction"}/></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section" id="how-it-works">
                <div className="section_content_container">
                    <div className="section_title_container">
                        <h3 className="section_title"><FormattedMessage id={"how_it_works"}/></h3>
                    </div>
                    <div className="paragraph_container">
                        <div className="paragraph">
                            <p className="custom_list_item">
                                <FormattedMessage id={"how_it_works_one"}/>
                            </p>
                            <p className="custom_list_item">
                                <FormattedMessage id={"how_it_works_two"}/>
                            </p>
                            <p className="custom_list_item">
                                <FormattedMessage id={"how_it_works_three"}/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div className="section" id="leasable-equipment">
                <div className="section_content_container">
                    <div className="section_title_container">
                        <h3 className="section_title"><FormattedMessage id={"leasable_equipment"}/></h3>
                    </div>
                    <div className="three_grid_container">
                        <div className="grid_content_container">
                            <img src={Algriculture} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"agriculture"}/></p>
                        </div>
                        <div className="grid_content_container">
                            <img src={Construction} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"contruction"}/></p>
                        </div>
                        <div className="grid_content_container">
                            <img src={Industrial} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"industrial"}/></p>
                        </div>
                        <div className="grid_content_container">
                            <img src={Landscaping} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"landscaping"}/></p>
                        </div>
                        <div className="grid_content_container">
                            <img src={Medical} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"medical"}/></p>
                        </div>
                        <div className="grid_content_container">
                            <img src={Office} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"office"}/></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="background">
            <div className="section" id="why-choose-us">
                <div className="section_content_container">
                    <div className="section_title_container">
                        <h3 className="section_title"><FormattedMessage id={"why_choose_us"}/></h3>
                    </div>
                    <div className="two_grid_paragraph_container">
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"get_equipment_fast"}/></h4>
                            <p>
                                <FormattedMessage id={"get_equipment_fast_introduction"}/>
                            </p>
                        </div>
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"increase_buying_power"}/></h4>
                            <p>
                            <FormattedMessage id={"increase_buying_power_introduction"}/>
                            </p>
                        </div>
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"control_cash_flow"}/></h4>
                            <p>
                                <FormattedMessage id={"control_cash_flow_introduction"}/>
                            </p>
                        </div>
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"potential_tax_saving"}/></h4>
                            <p>
                                <FormattedMessage id={"potential_tax_saving_introduction"}/>
                            </p>
                        </div>
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"custom_payment_streams"}/></h4>
                            <p>
                            <FormattedMessage id={"custom_payment_streams_introduction"}/>
                            </p>
                        </div>
                    </div>
                    <div className="paragraph_container">
                        <div className="highlight_paragraph"><FormattedMessage id={"financing"}/></div>
                    </div>
                </div>
            </div>
            <div className="section">
                <div className="section_content_container">
                    <div className="section_title_container">
                        <h3 className="section_title"><FormattedMessage id={"customize_payments"}/></h3>
                    </div>
                    <div className="five_grid_container">
                        <div className="grid_content_container">
                            <img src={FlexibleBuyoutOptions} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"flexible_buyout_options"}/></p>
                        </div>
                        <div className="grid_content_container">
                            <img src={ThreemonthSkipLease} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"threemonth_skip_lease"}/></p>
                        </div>
                        <div className="grid_content_container">
                            <img src={StepuporStepdownOption} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"step_option"}/></p>
                        </div>
                        <div className="grid_content_container">
                            <img src={FairMarketValue} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"fair_market_value"}/></p>
                        </div>
                        <div className="grid_content_container">
                            <img src={SeasonalPaymentPeriods} className="grid_image"/>
                            <p className="grid_description"><FormattedMessage id={"seasonal_payment"}/></p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div className="section">
                <div className="section_content_container">
                <div className="section_title_container">
                        <h3 className="section_title"><FormattedMessage id={"customer_feedback"}/></h3>
                    </div>
                    <FeedbackCard/>
                </div>
            </div>
            <div className="section" id="get-start">
                <div className="section_content_container">
                    <div className="section_title_container">
                        <h3 className="section_title"><FormattedMessage id={"how_to_get_started"}/></h3>
                    </div>
                    <div className="step_paragraph_container">
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"step_one"}/></h4>
                            <span className="paragraph_leading"><FormattedMessage id={"go_shopping"}/></span>
                            <p>
                                <FormattedMessage id={"step_one_introduction"}/>
                            </p>
                        </div>
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"step_two"}/></h4>
                            <span className="paragraph_leading"><FormattedMessage id={"complete_the_form"}/></span>
                            {/* <p>
                                <FormattedMessage id={"step_two_introduction"}/>
                            </p> */}
                            <a href="/request-a-demo" className="button-4 button-white w-button"><FormattedMessage id={"get_started"}/></a>
                        </div>
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"step_three"}/></h4>
                            <span className="paragraph_leading"><FormattedMessage id={"have_a_chat"}/></span>
                            <p>
                                <FormattedMessage id={"step_three_introduction"}/>
                            </p>
                        </div>
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"step_four"}/></h4>
                            <span className="paragraph_leading"><FormattedMessage id={"receive_equipment"}/></span>
                            <p>
                                <FormattedMessage id={"step_four_introduction"}/>
                            </p>
                        </div>
                        <div className="paragraph">
                            <h4 className="subtitle"><FormattedMessage id={"step_five"}/></h4>
                            <span className="paragraph_leading"><FormattedMessage id={"repeat_steps"}/></span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section" id="contact-us">
                <div className="section_content_container">
                    <div className="section_title_container">
                        <h3 className="section_title"><FormattedMessage id={"next_step"}/></h3>
                    </div>
                    <div className="paragraph_container">
                        <div className="paragraph">
                            <p>
                                <FormattedMessage id={"contact_learn_more"}/>
                            </p>
                            <ul>
                                {getData("contactData").head_office.offices.map(item => (
                                <>
                                    <li className="d-flex">
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        className="contact-icon"
                                    />
                                    <p>leasing@goopter.com</p>
                                    </li>
                                    <li className="d-flex">
                                    <FontAwesomeIcon
                                        icon={faPhoneAlt}
                                        className="contact-icon"
                                    />
                                    <p>{item.phone}</p>
                                    </li>
                                    <li className="d-flex">
                                    <FontAwesomeIcon
                                        icon={faMapMarkerAlt}
                                        className="contact-icon"
                                    />
                                    <div className="address-wrapper">
                                        {item.address.map(line => (
                                        <p>{line}</p>
                                        ))}
                                    </div>
                                    </li>
                                </>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <WaitingFor/>
        </div>
    );
}